import React, { Fragment } from 'react'
import './index.less'
import { goIndex } from '@/assets/js/utils'
class MyAsset extends React.Component {
    getdata (data, digit) {
        if (digit === '0') {
            return data.substring(0, 2)
        }
        if (digit === '1') {
            return data.substring(2)
        }
    }

    handleData (str) {
        const reg = RegExp(/\{.+\}/g)
        if (reg.test(str)) {
            return str.replace(/\{.+\}/, '')
        } else {
            return str
        }
    }

    render () {
        const { buriedPointEvent, data: { position, trackId, sublist = [], style } } = this.props
        const { backgroundColor, backgroundPicUrl } = style

        return (
            <Fragment>
                {
                    sublist.map((item, index) => {
                        return (
                            <div
                                className={'myAssetContainer statistics-dom'}
                                key={index}
                                style={{
                                    backgroundColor: backgroundColor || '',
                                    backgroundImage: backgroundPicUrl ? `url(${backgroundPicUrl})` : ''
                                }}
                            >
                                <div className={'myAssetLeft'}>
                                    <img className={'myYikaIcon'} src={item.iconUrl} alt='' ></img>
                                </div>
                                <div
                                    className={'myAssetRight'}
                                    onClick={() => {
                                        buriedPointEvent({
                                            button_name: `${trackId}`,
                                            button_id: `${item.id}`,
                                            button_order: `${index + 1}`,
                                            area_order: position,
                                            button_area: `${position}-${trackId}`
                                        })
                                        goIndex(item.url, trackId, item.keyword, {}, true)
                                    }}
                                >
                                    <span className={'myAssetRightOne'}>全部账单</span>
                                    {/* {!item.nearly7DayAmount && item.businessLine === '0931' ? (<span className={'myAssetRightOne'}>全部账单</span>)
                                        : (<span className={'myAssetRightOne'}>{this.handleData(item.cuePhrases)}</span>)}

                                    {item.nearly7DayAmount !== null && item.nearly7DayAmount !== '0' && item.businessLine === '0931'
                                        ? (<span className={'myAssetRightTwo'}>{item.nearly7DayAmount}</span>) : null} */}
                                    <span className={'myAssetRightThree'} />
                                </div>
                            </div>
                        )
                    })
                }
            </Fragment>

        )
    }
}

export default MyAsset
